"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMonthNumber = void 0;
const MONTH_TO_NUMBER = {
    JANUARY: 0,
    FEBRUARY: 1,
    MARCH: 2,
    APRIL: 3,
    MAY: 4,
    JUNE: 5,
    JULY: 6,
    AUGUST: 7,
    SEPTEMBER: 8,
    OCTOBER: 9,
    NOVEMBER: 10,
    DECEMBER: 11,
};
/**
 * @summary Returns the number of the given month name.
 *
 * Returns the number of the given month name. Note that counting begins at zero. If the given month name
 * does not exist, throws a `TypeError`.
 *
 * @param {string} month
 * @return {number}
 * @throws {TypeError}
 *
 * @example
 * setMonth(date, getMonthNumber('JANUARY'));
 */
function getMonthNumber(month) {
    if (month in MONTH_TO_NUMBER) {
        return MONTH_TO_NUMBER[month];
    }
    throw new TypeError(`Invalid month: ${month}.`);
}
exports.getMonthNumber = getMonthNumber;
